import { ReactNode } from 'react';

export const setDynamicPhrase = (
  phrase: string,
  replacedPart?: ReactNode,
): ReactNode[] | string => {
  const regex = /%{([^&\s]*)}%/;
  const partToReplace = regex.exec(phrase);

  if (!partToReplace?.length) {
    return phrase;
  } else if (!replacedPart) {
    return phrase.replace(regex, '').replace(/\s+/g, ' ');
  }

  return phrase
    .split(regex)
    .map((phraseSegment) =>
      phraseSegment === partToReplace[1] ? replacedPart || '' : phraseSegment,
    )
    .filter(Boolean);
};

export const capitalize = (text: string) => {
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const singularize = (word?: string | null) =>
  word?.length ? word.replace(/s\b/gi, '') : word;
